// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__PsZgt","productName":"Table_productName__24rQt"};